import { render, staticRenderFns } from "./BitacoraNovedadesIndex.vue?vue&type=template&id=2346f6d5"
import script from "./BitacoraNovedadesIndex.vue?vue&type=script&lang=js"
export * from "./BitacoraNovedadesIndex.vue?vue&type=script&lang=js"
import style0 from "./BitacoraNovedadesIndex.vue?vue&type=style&index=0&id=2346f6d5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports